import * as React from 'react';

import {useGetBucketedReportData} from 'shells/utils/hooks/use-get-bucketed-report-data';

import {mapBucketsFunction} from './helpers';

export type TopTenReport = {
    bucket: string;
    count: number;
}[];

export const useGetTopTenReport = (
    groupByField: 'state' | 'industryCodePrefix',
    filters?: any
): {
    isLoading: boolean;
    isError: string | null | undefined;
    topTenReport: TopTenReport | null | undefined;
} => {
    // Memoize params
    const params = React.useMemo(
        () => ({
            groupByField,
            filter: filters,
        }),
        [groupByField, filters]
    );

    const {reportData, isLoading, isError} = useGetBucketedReportData({
        reportUrl: 'mcfxcompanies/report',
        params,
        mapBucketsFunction,
        limit: 10,
    });

    // @ts-expect-error
    return {topTenReport: reportData, isLoading, isError};
};
